module.exports = __webpack_public_path__ + "static/media/the-simple-shellfish-that-fights-climate-change_hero.35fdf812.jpg";